export const secretKey = '3*U{m1q#t$>.I!/<0/^NXe"|6...gE';